// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"a5e47bb9","882":"665be2ca"}[chunkId] + ".chunk.css";
};